<template>
  <div class="row">
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Penultima Menstruación </label>
      <input type="date" class="form-control form-control-sm" v-model="embarazo_actual.penultima_menstruacion" >
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Ultima Menstruación <span class="text-danger">*</span></label>
      <input type="date" class="form-control form-control-sm" v-model="embarazo_actual.ultima_menstruacion" :class="{'is-invalid':$v.embarazo_actual.ultima_menstruacion.$error }">
      <small class="text-danger" v-if="!$v.embarazo_actual.ultima_menstruacion.validDateFormat">Fecha invalida</small>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Semanas de gestación <span class="text-danger">*</span></label>
      <input type="number" step="any" class="form-control form-control-sm" v-model="embarazo_actual.semanas_gestacion" :class="{'is-invalid':$v.embarazo_actual.semanas_gestacion.$error && $v.embarazo_actual.semanas_gestacion.$dirty}">
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Trimestre</label>
      <select class="form-control form-control-sm" v-model="embarazo_actual.trimestre">
        <option value="">--Seleccione--</option>
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="3">3</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Fecha probable de parto <span class="text-danger">*</span></label>
      <input type="date" class="form-control form-control-sm"  v-model="embarazo_actual.fecha_parto" :class="{'is-invalid':$v.embarazo_actual.fecha_parto.$error}">
      <small class="text-danger" v-if="!$v.embarazo_actual.fecha_parto.validDateFormat">Fecha invalida</small>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Presencia de movimientos fetales <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm" 
      v-model="embarazo_actual.movimientos_fetales" 
      :class="{'is-invalid':$v.embarazo_actual.movimientos_fetales.$error && $v.embarazo_actual.movimientos_fetales.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Sintomas urinarios <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.sintomas_urinarios" 
      :class="{'is-invalid':$v.embarazo_actual.sintomas_urinarios.$error && $v.embarazo_actual.sintomas_urinarios.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Sintomas cervico vaginales <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.cervico_vaginales" 
      :class="{'is-invalid':$v.embarazo_actual.cervico_vaginales.$error && $v.embarazo_actual.cervico_vaginales.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Cefalea persistente <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.cefalea_persistente" 
      :class="{'is-invalid':$v.embarazo_actual.cefalea_persistente.$error && $v.embarazo_actual.cefalea_persistente.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Edema en cara o miembros <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.edema" 
      :class="{'is-invalid':$v.embarazo_actual.edema.$error && $v.embarazo_actual.edema.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Epigastralgia <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.epigastralgia" 
      :class="{'is-invalid':$v.embarazo_actual.epigastralgia.$error && $v.embarazo_actual.epigastralgia.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
    <div class="form-group col-lg-4 col-md-12 col-sm-12">
      <label class="form-label">Nauseas y vomito <span class="text-danger">*</span></label>
      <select class="form-control form-control-sm"
      v-model="embarazo_actual.nauseas" 
      :class="{'is-invalid':$v.embarazo_actual.nauseas.$error && $v.embarazo_actual.nauseas.$dirty}">
        <option value="">--Seleccione--</option>
        <option value="SI">SI</option>
        <option value="NO">NO</option>
      </select>
    </div>
  </div>
</template>
<script>
import embarazoActualService from "../../../../services/embarazoActualService";
import Toast from '../../../../components/common/utilities/toast';
import {required} from "vuelidate/lib/validators";
import {isEmpty} from "lodash";
import embarazoService from '../../../../services/embarazoService';
import historiaClinicaService from '../../../../services/historiaClinicaService';
import {dateFormat} from "../../../../utils/validators/index";
import dayjs from "dayjs";

export default {
  props: ['idHistoria','finalizada','idUsuario','fechaHistoria'],
  data(){
    return {
      id_historia:'',
      fecha_historia:'',
      isCargando: false,
      embarazo_actual:{
        id:'',
        id_historia:'',
        id_embarazo:'',
        ultima_menstruacion:'',
        semanas_gestacion:'',
        trimestre:'',
        fecha_parto:'',
        movimientos_fetales:'',
        sintomas_urinarios:'',
        cervico_vaginales:'',
        cefalea_persistente:'',
        edema:'',
        epigastralgia:'', 
        nauseas:'',
        penultima_menstruacion:''
      },
      embarazo:{}
    }
  },
  validations (){
    return {
      embarazo_actual: {
        ultima_menstruacion:{
          validDateFormat:(value) => dateFormat(value),
          required
        },
        semanas_gestacion:{required},
        fecha_parto:{
          validDateFormat:(value) => dateFormat(value),
          required
        },
        movimientos_fetales:{required},
        sintomas_urinarios:{required},
        cervico_vaginales:{required},
        cefalea_persistente:{required},
        edema:{required},
        epigastralgia:{required}, 
        nauseas:{required}
      }
    }
  },
  methods: {
    calcularTrimestre(semanas){
      const sem = parseFloat(semanas);
      if(isNaN(sem) || sem <= 0) return '';
      if(sem < 14) return 1;
      if(sem < 28) return 2;
      return 3;
    },
    async setEmbarazoActual(data){
      this.embarazo_actual.id = data.id;
      this.embarazo_actual.id_historia = data.id_historia;
      this.embarazo_actual.id_embarazo = data.id_embarazo;
      this.embarazo_actual.ultima_menstruacion = data.ultima_menstruacion;
      this.embarazo_actual.semanas_gestacion = data.semanas_gestacion;
      this.embarazo_actual.trimestre = data.trimestre !== null && data.trimestre !== undefined && data.trimestre !== '' ? Number(data.trimestre) : this.calcularTrimestre(data.semanas_gestacion);
      this.embarazo_actual.fecha_parto = data.fecha_parto;
      this.embarazo_actual.movimientos_fetales = data.movimientos_fetales;
      this.embarazo_actual.sintomas_urinarios = data.sintomas_urinarios;
      this.embarazo_actual.cervico_vaginales = data.cervico_vaginales;
      this.embarazo_actual.cefalea_persistente = data.cefalea_persistente;
      this.embarazo_actual.edema = data.edema;
      this.embarazo_actual.epigastralgia = data.epigastralgia;
      this.embarazo_actual.nauseas = data.nauseas;
      this.embarazo_actual.penultima_menstruacion = data.penultima_menstruacion;
    },
    async cargarDatos(){
      this.isCargando = true;
      if(this.fechaHistoria){
        this.fecha_historia = this.fechaHistoria;
      }else if(this.idHistoria){
        const resHc = await historiaClinicaService.show(this.idHistoria);
        if(!isEmpty(resHc.data)){
          this.fecha_historia = resHc.data.fecha || resHc.data.created_at || '';
        }
      }

      this.embarazo_actual.fecha_parto = this.dateParto;
      if(this.finalizada==='N'){
        const res_embarazo_actual= await embarazoService.showByLast(this.idUsuario);
        this.embarazo=res_embarazo_actual.data;

        // 1. Verificar si ya existe registro para ESTA historia clínica
        const responseHc = await embarazoActualService.showByHc(this.idHistoria);
        if(!isEmpty(responseHc.data)){
          this.setEmbarazoActual(responseHc.data);
          this.id_historia = responseHc.data.id_historia;
          this.$nextTick(() => { this.isCargando = false; });
          return;
        }

        // 2. Si no existe en esta HC, pero hay embarazo previo, precargar datos del último control
        if(!isEmpty(this.embarazo)){
          const responseLast = await embarazoActualService.showByLast(this.embarazo.id);
          if(!isEmpty(responseLast.data)){
            this.setEmbarazoActual(responseLast.data);
            // Al ser un control nuevo para esta HC, vaciamos id e id_historia para que el primer guardado sea store
            this.embarazo_actual.id = '';
            this.id_historia = '';
            // Recalculamos las semanas con respecto a la fecha de esta consulta/historia y sugerimos trimestre
            this.embarazo_actual.semanas_gestacion = this.semanasGestacion;
            this.embarazo_actual.trimestre = this.calcularTrimestre(this.semanasGestacion);
          }
        }
      }
      this.$nextTick(() => { this.isCargando = false; });
    },
    async save(){
      try {
        this.$v.embarazo_actual.$touch();
        if(this.$v.embarazo_actual.$invalid) return;
        this.embarazo_actual.id_historia=this.idHistoria;
        this.embarazo_actual.id_embarazo= !isEmpty(this.embarazo) && this.embarazo.activo === 'S'?this.embarazo.id:null;
        this.LoaderSpinnerShow();
        if(this.id_historia!=='' && parseInt(this.id_historia)===parseInt(this.idHistoria)){
          await embarazoActualService.update(this.embarazo_actual);
        }else{
          const storeRes = await embarazoActualService.store(this.embarazo_actual);
          const response = await embarazoActualService.showByHc(this.idHistoria);
          if(!isEmpty(response.data)){
            this.embarazo_actual.id = response.data.id;
            this.id_historia = response.data.id_historia;
          } else if(storeRes && storeRes.data && storeRes.data.id) {
            this.embarazo_actual.id = storeRes.data.id;
            this.id_historia = this.idHistoria;
          } else {
            this.id_historia = this.idHistoria;
          }
        }

        this.LoaderSpinnerHide();
        Toast.fire({
            icon: 'success',
            title: 'Datos guardados con exito'
        });
      } catch (error) {
        console.error(error);
        this.LoaderSpinnerHide();
        Toast.fire({
            icon: 'error',
            title: 'Ocurrio un error al procesar la solicitud'
        });
            
      }
      
    },
  },
  watch:{
    fechaHistoria: function(val) {
      if(val){
        this.fecha_historia = val;
      }
    },
    finalizada: async function (value){
      if(value==='N'){
        await this.cargarDatos();
      }
    },
    'embarazo_actual.ultima_menstruacion': function(newVal, oldVal) {
      if (this.isCargando) return;
      this.embarazo_actual.fecha_parto = this.dateParto;
      if (oldVal !== undefined && newVal !== oldVal) {
        this.embarazo_actual.semanas_gestacion = this.semanasGestacion;
        this.embarazo_actual.trimestre = this.calcularTrimestre(this.semanasGestacion);
      }
    },
    'embarazo_actual.semanas_gestacion': function(newVal, oldVal) {
      if (this.isCargando) return;
      if (newVal !== '' && newVal !== null && oldVal !== undefined && newVal !== oldVal) {
        this.embarazo_actual.trimestre = this.calcularTrimestre(newVal);
      }
    }
  },
  async created(){
    await this.cargarDatos();
  },
  computed:{
    dateParto(){
      const fechaUltimaMenstruacion = dayjs(this.embarazo_actual.ultima_menstruacion);
      const fechaProbableParto = fechaUltimaMenstruacion.add(280, 'day');
      return  fechaProbableParto.format('YYYY-MM-DD');
    },
    semanasGestacion(){
      if (!this.embarazo_actual.ultima_menstruacion) return 0;
      const fechaUltimaMenstruacion = dayjs(this.embarazo_actual.ultima_menstruacion);
      if (!fechaUltimaMenstruacion.isValid()) return 0;

      // Usar la fecha de la historia clínica como fecha de corte; si no existe, usar la fecha actual
      const fechaRefStr = this.fecha_historia || this.fechaHistoria;
      const fechaReferencia = fechaRefStr ? dayjs(fechaRefStr) : dayjs();
      if (!fechaReferencia.isValid()) return 0;

      const diasGestacion = fechaReferencia.startOf('day').diff(fechaUltimaMenstruacion.startOf('day'), 'day');
      if (diasGestacion <= 0) return 0;

      const semanas = Math.floor(diasGestacion / 7);
      const diasRestantes = diasGestacion % 7;

      return diasRestantes > 0 ? parseFloat(`${semanas}.${diasRestantes}`) : semanas;
    }
  }
}
</script>